const ANSWER_OPTIONS = {
  YES: {display: 'YES', value: 'Yes', showOrder: 0, def: false},
  NO: {display: 'NO', value: 'No', showOrder: 1, def: false},
};
  
export default ANSWER_OPTIONS;